module.exports = __webpack_public_path__ + "homeStatic/media/company.f7012ac.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/company.mp4
// module id = dTcd
// module chunks = 1